import { cities } from "@/mocks/home";

export default function Cities() {
  return (
    <section id="cities" className="anchor-offset">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="mb-10 flex flex-col gap-3 md:max-w-2xl">
          <span className="text-xs font-medium uppercase tracking-widest text-primary-600">同城交友圈</span>
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">
            先认识住在你身边的人
          </h2>
          <p className="text-sm leading-relaxed text-foreground-700 md:text-base">
            同一座城市意味着共同的通勤路线、熟悉的地标和更低的见面成本。下面是活跃度较高的几个同城交友圈，
            每个圈子都有各自的相处节奏与热门场景。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {cities.map((city) => (
            <article
              key={city.name}
              className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center gap-2">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className="ri-map-pin-2-line text-lg" aria-hidden="true"></i>
                </span>
                <h3 className="font-heading text-lg text-foreground-950">{city.name}</h3>
              </div>
              <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-foreground-600">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-user-line" aria-hidden="true"></i>
                  活跃 {city.active}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-group-line" aria-hidden="true"></i>
                  {city.groups}
                </span>
              </div>
              <p className="text-sm leading-relaxed text-foreground-600">{city.vibe}</p>
            </article>
          ))}
        </div>

        <p className="mt-6 text-sm text-foreground-600">
          没有找到你的城市？可以先加入全国性的兴趣单身群，等本地成员变多后同城圈会陆续开放。
        </p>
      </div>
    </section>
  );
}